import React from 'react'; // Leave this import here
import * as Sentry from '@sentry/browser';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { routes, store } from './routes';

try {
  if (process.env.SENTRY_DSN) {
    Sentry.init(
      {
        dsn: process.env.SENTRY_DSN,
        environment: process.env.SENTRY_ENVIRONMENT,
        release: process.env.SENTRY_RELEASE,
      },
        );
  } else {
    // eslint-disable-next-line no-console
    console.log(`Sentry DSN not set`);
  }
} catch (e) {
  // if for some reason the sentry info is wrong we don't want to kill the entire bundle
  // eslint-disable-next-line no-console
  console.error(e);
}

const reactApp = document.getElementById(`react-container`);
if (reactApp) {
  render(
    <Provider
      store={store}
    >
      <Router
        routes={routes}
        history={browserHistory}
      />
    </Provider>,
    reactApp,
);
}



// WEBPACK FOOTER //
// ./library/app/index.js